<template lang="pug">
    .module-display(v-if="modules")
        ul.nav.nav-tabs.big-text(
            role="tablist"
        )
            li(
                v-for="date in moduleDateOrder"                
                @click="handleDateTabClick(date)"
                :class="{ active: date === shownModuleDate }"
                :id="date"
            )
                a(:href="`#${date}`") {{ formatDate(date) }}

        .module-list-wrapper(
            v-for="date in moduleDateOrder"
            v-if="date === shownModuleDate"
        )
            .time-wrapper(
                v-for="startTime in moduleTimeOrder[date]"
            )
                h4.event-modules-time-header Events starting at {{ formatTime(startTime) }}

                .module-display-wrapper(
                  v-for="(module, key) in modulesGroupedByStartTime[date][startTime]"
                )
                    input(
                        type="checkbox"
                        class="event-module-checkbox"
                        :value="module['code']"
                        v-model="selectedModules"
                        v-if="dateIsFuture(module['start_date'])"
                    )
                    h4.event-module-header(
                        @click="handleModuleTitleClick(module)"
                        :style="opacity(module)"
                    ) {{ module['title'] }}
                    
                    p.event-module-time(:style="opacity(module)") 
                        | {{ fullModuleTime(module) }} 
                        span(
                            v-if="module.tutors.length > 0"
                        ) with 
                        span.tutor-item(
                            v-for="(tutor, index) in module.tutors"                            
                        ) {{ tutor.title }} {{ tutor.firstname }} {{ tutor.surname }}
                        
                    p(v-html="module['overview']" v-if="!module['full']")
                    p(
                        v-if="module['full']"
                        class="text-danger"
                    ) This session is full. However, you can enrol on the waiting list.

</template>

<script>

var _ = require('lodash');
var moment = require('moment');

export default {
    name: 'ModuleDisplay',
    props: ['modules'],
    data: function() {
        return {
            shownModuleDate: '',
            selectedModules: []
        };
    },

    computed: {
        modulesGroupedByStartTime() {
            return _.mapValues(this.modules, this.groupModulesByStartTime);
        },

        shownModuleDateComp() {
            return this.shownModuleDate;
        },

        // keys from the grouped modules, in date order
        moduleDateOrder() {
            return _(this.modules)
              .mapValues(this.groupModulesByStartTime)
              .keys()
              .orderBy((date) => {
                  return moment(date, this.$store.getters.dateFormat).unix()
              })
              .value()

        },

        // keys from each date's group of modules, ordered by start time
        moduleTimeOrder() {
            return _(this.modules)
                .mapValues(this.groupModulesByStartTime)              // get modules grouped according to start time
                .mapValues(moduleGroup => {
                    return _(moduleGroup)
                        .keys()                                       // get the keys of the module group (which is a time)
                        .orderBy(time => {                            // order the times
                            return moment(
                                time, this.$store.getters.timeFormat
                            ).unix()                                  // unix time is used here because it makes ordering easy
                        })
                        .value()
                })
                .value()
        },
    },

    methods: {
        dateIsFuture(date) {
            return moment(date, this.$store.getters.dateFormat).isAfter(moment(new Date()).subtract(1, 'days'));
        },

        formatTime(time) {
            return moment(time, this.$store.getters.timeFormat).format("h:mma");
        },

        formatDate(date) {
            return moment(date, this.$store.getters.dateFormat).format("dddd DD MMMM Y");
        },

        fullModuleTime(module) {
            let startTime = this.formatTime(module['start_time']);
            let endTime = this.formatTime(module['end_time']);
            return `${startTime} - ${endTime}`;
        },

        groupModulesByStartTime(moduleList) {
            return _.groupBy(moduleList, module => module['start_time']);
        },

        /**
        * toggles whether the module passed is present in selectedModules
        * @param {object} module - the module object to toggle
        */
        handleModuleTitleClick(module) {
            let moduleCode = module['code'];
            let foundModule = false;

            // toggle the selected module
            for (let i = 0; i < this.selectedModules.length; i++) {
                let thisModule = this.selectedModules[i];

                // if we find the module, remove it
                if (thisModule === moduleCode) {
                    this.selectedModules.splice(i, 1);
                    foundModule = true;
                }
            }

            // if the module was not present, add it
            if (!foundModule) {
                this.selectedModules.push(moduleCode);
            }
        },
		
		opacity(module) {
			return module['full'] ? {opacity: .5} : {}
		},

        /**
         * handles clicks on date tabs
         */
        handleDateTabClick(date) {
          console.log(date + 'WHAT');
          console.dir(this.selectedModules)
          this.shownModuleDate = date;
        },

    },

    watch: {
        moduleDateOrder() {
            // filter out dates in the past
            let futureDates = _(this.moduleDateOrder)
                .filter(date => this.dateIsFuture(date))
                .value()
                
            // Display the next future date, or fall back to the first date
            this.shownModuleDate = futureDates[0] || this.moduleDateOrder[0];
            
        },

        selectedModules(val) {
            this.$emit('selectedModuleChange', { modules: val });
        },
    }
}

</script>

<style lang="stylus" scoped>
    h4.event-module-header
        display: inline-block
        margin-right: 1em
    .tutor-item  + .tutor-item:before
        content: ", "
    .event-module-checkbox
        margin-right: 7px
</style>



// WEBPACK FOOTER //
// src/components/ModuleDisplay.vue